module.exports = __webpack_public_path__ + "img/orders20.22c0e87e.png";